import React from "react";
import { usePayment } from "../../../context/contextPayment";

const BillingComponent = () => {
  const { 
    invoice, 
    loadingInvoice, 
    handleViewInvoiceHtml 
  } = usePayment();

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Billing</h2>

      {/* Loading Spinner */}
      {loadingInvoice && (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* No Records */}
      {!loadingInvoice && (!invoice || invoice.length === 0) && (
        <div className="text-center text-muted py-5">
          No billing history available.
        </div>
      )}

      {/* Invoice Table */}
      {!loadingInvoice && invoice && invoice.length > 0 && (
        <div className="table-responsive mt-3">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Invoice</th>
              </tr>
            </thead>

            <tbody>
              {invoice.map((inv, index) => (
                <tr key={`${inv.invoice_id}-${index}`}>
                  <td>
                    {inv.created_at
                      ? new Date(inv.created_at * 1000).toLocaleDateString("en-IN")
                      : "—"}
                  </td>
                  <td className="fw-semibold">
                    ₹{Number(inv.amount / 100).toLocaleString("en-IN")}
                  </td>
                  <td>
                    {inv.status === "paid" && (
                      <span className="badge bg-success">Paid</span>
                    )}

                    {inv.status === "issued" && (
                      <span className="badge bg-warning text-dark">Issued</span>
                    )}

                    {inv.status === "failed" && (
                      <span className="badge bg-danger">Failed</span>
                    )}

                    {!["paid", "issued", "failed"].includes(inv.status) && (
                      <span className="badge bg-secondary">
                        {inv.status
                          ? inv.status.charAt(0).toUpperCase() + inv.status.slice(1)
                          : "—"}
                      </span>
                    )}
                  </td>

                  <td>
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={async () => await handleViewInvoiceHtml(inv.invoice_id)}
                    >
                      View Invoice
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BillingComponent;
